import './VideoTutorial.scss';
import { ReactNode, useState } from 'react';
import { MdHelpOutline } from 'react-icons/md';
import { Appearance, Size } from '../designConstants';
import { IconButton } from '../IconButton';
import { Tray } from './Tray';
import { VideoInfo } from './videoTutorialUtils';

interface VideoTutorialProps {
  showHelpButton: boolean;
  videoList: VideoInfo[] | undefined;
}

export const VideoTutorial = ({ showHelpButton, videoList }: VideoTutorialProps): ReactNode => {
  const [showVideoTray, setShowVideoTray] = useState(false);
  const videoContentList = videoList ?? [];

  const helpButtonView = (
    <div className='button-container'>
      <IconButton
        className='help-pill-button'
        size={Size.LG}
        appearance={Appearance.FILLED}
        title='Help'
        onClick={() => setShowVideoTray(true)}
      >
        <MdHelpOutline className='help-button-question-icon' />
      </IconButton>
    </div>
  );

  const trayView = showVideoTray ? (
    <Tray setShowExpandedTray={setShowVideoTray} videoList={videoContentList} />
  ) : (
    <div />
  );
  return (
    <div>
      {showHelpButton && helpButtonView}
      {showVideoTray && trayView}
    </div>
  );
};
